import { useMemo } from "react";
import { IdleDetailingItem, WorkDisplayPeriod } from "@baseTypes/service/dashboard/IWorksDashboardService";
import { isEqual, isToday, startOfDay } from "date-fns";
import { useTypedSelector } from "@hooks/useTypedSelector";

export const useElementsToDrawByPeriod = (period: WorkDisplayPeriod, elements: IdleDetailingItem[]) => {
    const { selectedDate } = useTypedSelector(state => state.selectedDate)
    return useMemo(() => {
        if (period === 'full') {
            return elements
        } else {
            const todayIdle = elements.find(idle => {
                return selectedDate && isEqual(startOfDay(idle.date), startOfDay(selectedDate))
            })
            return todayIdle ? [todayIdle] : []
        }
    }, [period, elements, selectedDate])
}